import {useForm} from 'react-hook-form';
import {withRouter,Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import cogoToast from 'cogo-toast';
import {useLocation} from 'react-router-dom';
import userService from "../services/users-service"
const ResetPassword = ({history}) => {
  const {register, handleSubmit,errors} = useForm({});
  const search = useLocation().search;
  const onSubmit = async (data) => {
    try {
      const token = new URLSearchParams(search).get('token');
      const changePwdArray = {
        token: token,
        password: data.newpassword
      }
      const changePwdMsg = await userService.resetPassword(changePwdArray);      
      if (changePwdMsg && changePwdMsg.code===200) {
        const { hide } = cogoToast.success('Password has been Reset Succesfully', {hideAfter:15,
          onClick: () => {
            hide();
          },
        });
        await history.push('/');    
      }
    } catch (e) {
      const { hide } = cogoToast.error('Password update failed. Please contact administrator.', {hideAfter:15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  return (
    <>
      <div className="login_section bg-hero-pattern bg-cover pb-60">
        <div className="w-11/12 mx-20 login_section">
          <div className=""><img src="img/CSP_logo.png" className="w-3/12 pt-4" alt="logo"/></div>
          <div className="bg-white w-4/12 mt-32 ml-96 shadow-md rounded-md">
            <div className="text-center pt-5 pb-1 font-bold text-grey_color">RESET PASSWORD ?</div>
            <div className="pt-5 pr-12 pb-5 pl-12">
              <form onSubmit={handleSubmit(onSubmit)}>
                <ul className="text-left">
                  <li className="inline-block text-sm leading-8 w-full">
                    <input
                      id='newpassword'
                      name='newpassword'
                      type='password'
                      placeholder='Enter Your New Password'
                      autoComplete=''
                      ref={register({
                        required: 'You must Enter the New Password',
                        pattern: {
                          value: /^(?=.*[0-9])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,}$/i,
                          message: "Password should be atleast 8 character long,one upper case letter,one number at the minimum"
                        }
                      })}
                      className='border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full'
                    />
                    {errors.newpassword && (
                  <p className='text-xs md:text-sm md:pt-1 text-hlred'>
                    {errors.newpassword?.message}
                  </p>
                )}
                  </li>
                  <li className="inline-block text-sm leading-8 w-full">

                    <button
                      type='submit'
                      className='text-white rounded font-medium h-10 text-white w-full bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none'
                      aria-label='submit'
                    >
                      SEND
                    </button>
                  </li>
                  <li className="inline-block text-sm leading-8 w-full text-center text-fogotpwsd_login">
                    <Link to="/">Back To Login</Link></li>
                </ul>
              </form>
            </div>

          </div>

        </div>
      </div>
    </>
  );
};


export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    },
  )(ResetPassword),
);